export enum VisualizationType {
	Sector = 'Sector',
	Tags = 'Tags',
	Geography = 'Geography',
	FocusArea = 'FocusArea',
	TherapeuticArea = 'TherapeuticArea',
}
